import { render, staticRenderFns } from "./VehiculoDocumento.vue?vue&type=template&id=077ad082"
import script from "./VehiculoDocumento.vue?vue&type=script&lang=js"
export * from "./VehiculoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports